import React from 'react';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { RemoveIncidentForm } from 'modules/components/layer12';

export type RemoveIncidentModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveIncidentModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove incident'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveIncidentForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
